/*
 * -----------------------------
 * Fade
 * -----------------------------
 */
const defaultTarget = {
  id: 'N/A',
  appliesTo: 'TRIGGER_ELEMENT',
  useEventTarget: true,
} as const;

export const fadeIn = {
  id: `fadeIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const fadeOut = {
  id: `fadeOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Slide
 * -----------------------------
 */
export const slideInBottom = {
  id: `slideInBottom`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const slideInTop = {
  id: `slideInTop`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInLeft = {
  id: `slideInLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -100,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInRight = {
  id: `slideInRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 100,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInBottomLeft = {
  id: `slideInBottomLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -100,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInTopLeft = {
  id: `slideInTopLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -100,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInBottomRight = {
  id: `slideInBottomRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 100,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideInTopRight = {
  id: `slideInTopRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 100,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutBottom = {
  id: `slideOutBottom`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutTop = {
  id: `slideOutTop`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutLeft = {
  id: `slideOutLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -100,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutRight = {
  id: `slideOutRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 100,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutBottomLeft = {
  id: `slideOutBottomLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -100,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutTopLeft = {
  id: `slideOutTopLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -100,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutBottomRight = {
  id: `slideOutBottomRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 100,
            yValue: 100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const slideOutTopRight = {
  id: `slideOutTopRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 100,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Grow
 * -----------------------------
 */
export const growBigIn = {
  id: `growBigIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const growIn = {
  id: `growIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.7500000000000001,
            yValue: 0.7500000000000001,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const growBigOut = {
  id: `growBigOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 4,
            yValue: 4,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const growOut = {
  id: `growOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1.25,
            yValue: 1.25,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Shrink
 * -----------------------------
 */
export const shrinkBigIn = {
  id: `shrinkBigIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 4,
            yValue: 4,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const shrinkIn = {
  id: `shrinkIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 1.25,
            yValue: 1.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const shrinkBigOut = {
  id: `shrinkBigOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const shrinkOut = {
  id: `shrinkOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.7500000000000001,
            yValue: 0.7500000000000001,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Flip
 * -----------------------------
 */
export const flipInBottom = {
  id: `flipInBottom`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -90,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flipInTop = {
  id: `flipInTop`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 90,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flipInLeft = {
  id: `flipInLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: -90,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flipInRight = {
  id: `flipInRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: 90,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flipOutBottom = {
  id: `flipOutBottom`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -90,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flipOutTop = {
  id: `flipOutTop`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 90,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flipOutLeft = {
  id: `flipOutLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: -90,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flipOutRight = {
  id: `flipOutRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 90,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Spin
 * -----------------------------
 */
export const spinInClockwise = {
  id: `spinInClockwise`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: -900,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const spinInCounterClockwise = {
  id: `spinInCounterClockwise`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 900,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const spinOutClockwise = {
  id: `spinOutClockwise`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 900,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const spinOutCounterClockwise = {
  id: `spinOutCounterClockwise`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: -900,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Drop
 * -----------------------------
 */
export const dropIn = {
  id: `dropIn`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            yValue: -500,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outBounce',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            zValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const dropOut = {
  id: `dropOut`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuint',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 500,
            zValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuint',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Fly
 * -----------------------------
 */
export const flyInBottom = {
  id: `flyInBottom`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInTop = {
  id: `flyInTop`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInLeft = {
  id: `flyInLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInRight = {
  id: `flyInRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInBottomLeft = {
  id: `flyInBottomLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -800,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInBottomRight = {
  id: `flyInBottomRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 800,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInTopLeft = {
  id: `flyInTopLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: -800,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyInTopRight = {
  id: `flyInTopRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 800,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 120,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 120,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 120,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutBottom = {
  id: `flyOutBottom`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutTop = {
  id: `flyOutTop`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutLeft = {
  id: `flyOutLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutRight = {
  id: `flyOutRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutBottomLeft = {
  id: `flyOutBottomLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -800,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutBottomRight = {
  id: `flyOutBottomRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 800,
            yValue: 800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutTopLeft = {
  id: `flyOutTopLeft`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: -800,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const flyOutTopRight = {
  id: `flyOutTopRight`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'inOutQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 0.25,
            yValue: 0.25,
          },
        },
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 800,
            yValue: -800,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'inQuart',
            duration: 1000,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

/*
 * -----------------------------
 * Emphasis
 * -----------------------------
 */
export const blink = {
  id: `blink`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'STYLE_OPACITY',
          config: {
            delay: 0,
            easing: 'outQuad',
            duration: 120,
            target: defaultTarget,
            value: 1,
          },
        },
      ],
    },
  ],
} as const;

export const bounce = {
  id: `bounce`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 250,
            target: defaultTarget,
            yValue: -100,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_MOVE',
          config: {
            delay: 0,
            easing: 'outBounce',
            duration: 1000,
            target: defaultTarget,
            yValue: 0,
            xUnit: 'PX',
            yUnit: 'PX',
            zUnit: 'PX',
          },
        },
      ],
    },
  ],
} as const;

export const flipLeftToRight = {
  id: `flipLeftToRight`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            duration: 0,
            target: defaultTarget,

            yValue: -720,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'swingFromTo',
            duration: 1000,
            target: defaultTarget,

            yValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,

            xValue: 1.05,
            yValue: 1.05,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'swingTo',
            duration: 250,
            target: defaultTarget,

            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
  ],
} as const;

export const flipRightToLeft = {
  id: `flipRightToLeft`,
  useFirstGroupAsInitialState: true,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            duration: 0,
            delay: 0,
            target: defaultTarget,
            yValue: 720,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'swingFromTo',
            duration: 1000,
            target: defaultTarget,
            yValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 1000,
            target: defaultTarget,
            xValue: 1.05,
            yValue: 1.05,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'swingTo',
            duration: 250,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
  ],
} as const;

export const jiggle = {
  id: `jiggle`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: -5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: -5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: -5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: -5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: -5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 5,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_ROTATE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            zValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
  ],
} as const;

export const pop = {
  id: `pop`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 250,
            target: defaultTarget,
            xValue: 0.7500000000000001,
            yValue: 0.7500000000000001,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outElastic',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
  ],
} as const;

export const pulse = {
  id: `pulse`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1.1,
            yValue: 1.1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1.1,
            yValue: 1.1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1.1,
            yValue: 1.1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1.1,
            yValue: 1.1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1.1,
            yValue: 1.1,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'ease',
            duration: 100,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
  ],
} as const;

export const rubberBand = {
  id: `rubberBand`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 250,
            target: defaultTarget,
            xValue: 1.25,
            yValue: 0.7500000000000001,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SCALE',
          config: {
            delay: 0,
            easing: 'outElastic',
            duration: 1000,
            target: defaultTarget,
            xValue: 1,
            yValue: 1,
          },
        },
      ],
    },
  ],
} as const;

export const jello = {
  id: `jello`,
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SKEW',
          config: {
            delay: 0,
            easing: 'outQuart',
            duration: 100,
            target: defaultTarget,
            xValue: -12,
            yValue: -12,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'TRANSFORM_SKEW',
          config: {
            delay: 0,
            easing: 'outElastic',
            duration: 1000,
            target: defaultTarget,
            xValue: 0,
            yValue: 0,
            xUnit: 'DEG',
            yUnit: 'DEG',
            zUnit: 'DEG',
          },
        },
      ],
    },
  ],
} as const;

export const pluginLottie = {
  id: 'pluginLottie',
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 'auto',
            target: defaultTarget,
            value: 100,
          },
        },
      ],
    },
  ],
} as const;

export const pluginLottieReverse = {
  id: 'pluginLottieReverse',
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 100,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 'auto',
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const pluginLottieLoop = {
  id: 'pluginLottieLoop',
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 'auto',
            target: defaultTarget,
            value: 100,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
  ],
} as const;

export const pluginLottieLoopReverse = {
  id: 'pluginLottieLoopReverse',
  actionItemGroups: [
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 100,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 'auto',
            target: defaultTarget,
            value: 0,
          },
        },
      ],
    },
    {
      actionItems: [
        {
          actionTypeId: 'PLUGIN_LOTTIE',
          config: {
            delay: 0,
            easing: '',
            duration: 0,
            target: defaultTarget,
            value: 100,
          },
        },
      ],
    },
  ],
} as const;
